// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3QphY","amount":"Amount_amount__4iy7A","tip":"Amount_tip__1ublA","tipHeader":"Amount_tipHeader__1_9K2","tipsWrap":"Amount_tipsWrap__2-Qi_"};